import { connect } from 'react-redux';
import IssuePaneSuggestionTab from './IssuePaneSuggestionTab';
import { IIssuePaneSuggestionTabStateProps } from './IssuePaneSuggestionTab-types';

function mapStateToProps(): IIssuePaneSuggestionTabStateProps {
    return {};
}

export default connect(mapStateToProps)(IssuePaneSuggestionTab);
